import React, { useEffect, useState } from 'react';
import { Country, Job } from '../../../global';
import axiosHelper from '../../../helpers/axiosHelper';
import styles from './DropDown.module.scss';
import { GenericSelect } from './GenericSelect';

interface Props {
  value?: Job | null;
  onChange: (job: Job | null) => void;
}

const JobSelect: React.FC<Props> = ({ value, onChange }) => {
  const [jobs, setJobs] = useState<Job[]>([]);

  useEffect(() => {
    getJobs();
  }, []);

  const getJobs = async () => {
    let result: Job[] = await axiosHelper.getJobs();
    if (result) {
      // console.log(result);
      setJobs(result);
    }
  };
  return <GenericSelect items={jobs} value={value} onChange={onChange} placeholder="Select job..." renderItem={(c) => c.name} />;

};

export default JobSelect;
